import { ApiBase } from "~/extensions/api";
import { GetAdminInformationCommand } from "./ccommands/GetAdminInformationCommand";
import { InsertAdminInformationCommand } from "./ccommands/InsertAdminInformationCommand";
import { UpdateAdminInformationCommand } from "./ccommands/UpdateAdminInformationCommand";
import { DeleteAdminInformationCommand } from "./ccommands/DeleteAdminInformationCommand";
import { FindAdminInformationCommand } from "./ccommands/FindAdminInformationCommand";
export class AdminInformationApi extends ApiBase {
    /**検索API */
    findAdmin(model, pagination) {
        let command = new FindAdminInformationCommand(model);
        pagination.applyTo(command);
        return this.request(command);
    }
    /**取得API */
    getAdmin(informationNo) {
        let command = new GetAdminInformationCommand(informationNo);
        return this.request(command);
    }
    /**登録API */
    insertAdmin(model) {
        let command = new InsertAdminInformationCommand(model);
        return this.request(command);
    }
    /**更新API */
    updateAdmin(model) {
        let command = new UpdateAdminInformationCommand(model);
        return this.request(command);
    }
    /**削除API */
    deleteAdmin(informationNo) {
        let command = new DeleteAdminInformationCommand(informationNo);
        return this.request(command);
    }
}
